import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import { partnerListQuery } from "@/features/partners/api";
import { PartnersPage } from "@/features/partners/PartnersPage";
import { validatePartnerSearch, type PartnerSearch } from "@/features/partners/search";
import { partnerListColumns } from "@patronix/domain/list";
import { viewQuery } from "@/lib/listView";

export const Route = createFileRoute("/_app/sales/customers")({
  validateSearch: validatePartnerSearch,
  loaderDeps: ({ search }) => ({ q: search.q, inactive: search.inactive, f: search.f, s: search.s }),
  loader: ({ context, deps }) => context.queryClient.ensureInfiniteQueryData(partnerListQuery({ role: "customer", q: deps.q, inactive: deps.inactive, ...viewQuery(partnerListColumns, deps) })),
  component: Page,
});

function Page() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const setSearch = useCallback(
    (patch: Partial<PartnerSearch>) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true }),
    [navigate],
  );
  return <PartnersPage role="customer" search={search} setSearch={setSearch} />;
}
